Ext.define('SA.model.createimport.FileStepValidator', {
    constructor(model) {
        this.model = model;

        this.tupleListValidator = new SA.model.createimport.FileTupleListValidator(model.getTupleList());
    },

    getDatasetName() {
        return this.model.getDatasetName();
    },

    getNamesOfUnreadableFiles() {
        var files = this.model.getTupleList().getFiles();

        return files.filter(file => file.isUnreadable()).map(file => file.getFileName());
    },

    getValidatorsForInvalidFiles() {
        return this.tupleListValidator.getValidatorsForInvalidFiles();
    },

    hasBlankDatasetName() {
        return this.model.getDatasetName() === '';
    },

    hasDifferentColumnCountsAcrossFiles() {
        return this.tupleListValidator.hasDifferentColumnCountsAcrossFiles();
    },

    hasDuplicateDatasetName() {
        var name = this.getDatasetName().toLowerCase(),
            existingNames = SA.data.UserDatasets.getNames().map(name => name.toLowerCase());

        return existingNames.includes(name);
    },

    hasDuplicateUnits() {
        return this.tupleListValidator.hasDuplicateUnits();
    },

    hasFileWithMoreThanOneUniqueHeaderName() {
        return this.tupleListValidator.hasFileWithMoreThanOneUniqueHeaderName();
    },

    hasFileWithoutUnit() {
        return this.tupleListValidator.hasFileWithoutUnit();
    },

    hasInvalidTuples() {
        return this.tupleListValidator.hasInvalidTuples();
    },

    hasNoFiles() {
        return this.tupleListValidator.isEmpty();
    },

    hasUnitWithoutFile() {
        return this.tupleListValidator.hasUnitWithoutFile();
    },

    isValid() {
        return !this.hasBlankDatasetName() && !this.hasDuplicateDatasetName() && this.tupleListValidator.isValid();
    }
});